import { Option } from 'src/shared/form/control'
import { PROCESS } from 'src/shared/constants/constants'
import {
  MILESTONE_RESPONSIBLE_TYPE_TYPE,
  MILESTONE_TYPE,
  MILESTONE_TYPE_TYPE,
} from 'src/shared/constants/milestone-constants'

import { getTranslationForProcess } from 'src/screens/administration/configuration-management/ConfigurationUtils'
import { Milestone_Config } from 'src/@types/graphql'
import { DateUtils } from 'src/shared/utils/DateUtils'
import { SupportedLocale } from 'src/@types'

export const mapMilestoneTypesToOptions = (milestoneTypes: MILESTONE_TYPE_TYPE[]): Option[] =>
  milestoneTypes.map((value) => ({
    label: '',
    value: value,
  }))

export const mapMilestoneResponsibleTypesToOptions = (
  milestoneResponsibleTypes: MILESTONE_RESPONSIBLE_TYPE_TYPE[],
): Option[] =>
  milestoneResponsibleTypes.map((value) => ({
    label: '',
    value: value,
  }))

export const getMilestoneConfigProcessOptions = (
  getMessage: (key: string, params?: Array<string | number>) => string,
): Option[] => {
  return MILESTONE_CONFIG_PROCESSES.map((process) => ({
    label: getTranslationForProcess(getMessage, process),
    value: process,
  }))
}

export const getMilestoneConfigDueDate = (
  mc: Milestone_Config,
  getMessage: (key: string, params?: Array<string | number>) => string,
  locale: SupportedLocale,
): string => {
  const CONTRACT_PROCESSES = [PROCESS.PF_KAP, PROCESS.PF_PGV] as string[]
  const isBasedOnContract = CONTRACT_PROCESSES.includes(mc.process)

  switch (mc.type) {
    case MILESTONE_TYPE.CONTRACT:
      return isBasedOnContract
        ? getMessage('label.project.contract.start.date')
        : getMessage('label.kap.program.start.date')
    case MILESTONE_TYPE.FINAL_REPORT: {
      if (isBasedOnContract) {
        return getMessage('label.project.contract.end.date')
      }
      break
    }
  }

  const monthName = mc.month ? DateUtils.getMonthName(mc.month, DateUtils.FULL_MONTH, locale) : null
  return mc.day && monthName ? `${mc.day}. ${monthName}` : mc.day || monthName || null
}

const MILESTONE_CONFIG_PROCESSES = [PROCESS.PF_KAP, PROCESS.PF_PGV, PROCESS.KAP]

export { MILESTONE_CONFIG_PROCESSES }
